import { FC, useCallback } from 'react'

import { useUnit } from 'effector-react'
import ReactDropzone, { DropzoneProps } from 'react-dropzone'

import { $hasEditVaultPermission } from '@/models/permissions.ts'

import { setIsDropping } from './models'

const mockedRootProps = () => ({})

export const Dropzone: FC<DropzoneProps> = ({ onDrop, children }) => {
  const handleDrop = useCallback(
    (...args: Parameters<NonNullable<DropzoneProps['onDrop']>>) => {
      onDrop?.(...args)
      setIsDropping(false)
    },
    [onDrop],
  )
  const hasEditVaultPermission = useUnit($hasEditVaultPermission)
  const handleDropIn = useCallback(() => setIsDropping(true), [])
  const handleDropOff = useCallback(() => setIsDropping(false), [])

  return hasEditVaultPermission ? (
    <ReactDropzone
      onDragEnter={handleDropIn}
      onDragLeave={handleDropOff}
      onDrop={handleDrop}
    >
      {children}
    </ReactDropzone>
  ) : (
    // @ts-ignore
    children?.({ getRootProps: mockedRootProps })
  )
}
